import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className="flex items-center gap-1 text-xs text-[#838F80] py-3 overflow-x-auto" data-testid="breadcrumbs" aria-label="Breadcrumb">
      <Link to="/" className="hover:text-[#2D5A3D] transition-colors whitespace-nowrap">Home</Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1">
          <ChevronRight className="w-3 h-3 flex-shrink-0" />
          {item.href ? (
            <Link to={item.href} className="hover:text-[#2D5A3D] transition-colors whitespace-nowrap">{item.label}</Link>
          ) : (
            <span className="text-[#4B5548] truncate max-w-[200px]">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
